import queryString from 'query-string';
const buildLink = ({ pathname, query }) => `${pathname}?${queryString.stringify(query)}`;
export default buildLink;
